import {
  parseAuthMethod,
  queueAuthCompletion,
} from "@/analytics";
import { PublicShell } from "@/components/layout/PublicShell";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

const Callback = () => {
  const [searchParams] = useSearchParams();
  const raw = sessionStorage.getItem("returnTo") || "/";
  const returnTo = useRef(raw.startsWith("/") && !raw.startsWith("//") ? raw : "/").current;
  const token = searchParams.get("token");
  const isCLILogin = searchParams.get("is-cli-login") === "true";
  // Every login redirect carries isSignUp, so its absence means this page was
  // opened directly rather than reached from the API.
  const isLoginRedirect = searchParams.has("isSignUp") || Boolean(token);
  useEffect(() => {
    if (!isLoginRedirect) {
      window.location.replace("/authn/login");
      return;
    }
    // The session lives in the httpOnly cookie the backend set on this
    // redirect. A token in the URL means the cookie cannot reach this console,
    // as in local dev where it is cross-site to its API, so the token keeps
    // authenticating this tab. Otherwise drop any leftover, or its expired
    // value would shadow the fresh cookie.
    if (token) {
      sessionStorage.setItem("token", token);
    } else {
      sessionStorage.removeItem("token");
    }
    localStorage.removeItem("token");
    queueAuthCompletion({
      provider: parseAuthMethod(localStorage.getItem("lastUsedAuthnProvider")),
      auth_flow: isCLILogin ? "cli" : "console",
      account_state: searchParams.get("isSignUp") === "true" ? "new" : "existing",
    });
    window.location.replace(isCLILogin ? "/authn/cli" : returnTo);
  }, [isCLILogin, isLoginRedirect, returnTo, searchParams, token]);
  return <PublicShell><p role="status" className="text-center text-muted-foreground">Verifying your sign-in...</p></PublicShell>;
};

export default Callback;
